module.exports = window.angular;